import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';

import { sharedEnhancer } from '../Shared';
import { productsImport, deleteImportedProducts } from '../../actions';
import confirmModal from '../../../../common/confirmModal';

const enhance = compose(
  connect(null, { import: productsImport, deleteImportedProducts }),
  withProps(() => ({
    previewOrder: [
      'Name', 'SKU', 'Price', 'Supply Price', 'Inventory',
      'Low Inventory Threshold', 'Description',
    ],
  })),
  sharedEnhancer,
  withHandlers({
    onSubmit: props => (e) => {
      props.onSubmit(e).then((response) => {
        props.addNotification({
          level: 'success',
          message: `Imported ${response.length} items.`,
          title: 'Success',
        });
      });
    },
    deleteProducts: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete imported products',
        message: 'Are you sure you want to delete imported products at the shop?',
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteImportedProducts(props.params.id).then(response => props.addNotification({
        level: 'success',
        message: `Deleted ${response.deleted} products.`,
        autoDismiss: 20,
        title: 'Success',
      }));
    },
  }),
);

export default enhance;
